/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import monitoringService from 'infrastructure/serviceHandlers/Monitoring/Monitoring';
import { getPiggybankPlanDetails } from 'services/api/plansApi';
import { TOneTimeDataPlanState, TPlanList } from 'typings';

export const fetchOneTimeDataPlans = createAsyncThunk(
  'fetchOneTimeDataPlans',
  async (
    payload: {
      country: string;
      category: string;
      type: string;
    },
    thunkAPI
  ) => {
    try {
      const response = await getPiggybankPlanDetails(payload);
      return response.data;
    } catch (error) {
      monitoringService.captureException(error, {
        tags: {
          feature: 'fetchOneTimeDataPlans',
          error_type: 'api_error'
        },
        extra: {
          payload
        }
      });
      return thunkAPI.rejectWithValue('failed');
    }
  }
);

const initialPlanState: TOneTimeDataPlanState = {
  oneTimeDataPlans: [],
  isLoading: false
};

export const allPlanSlice = createSlice({
  name: 'fetchOneTimeDataPlans',
  initialState: initialPlanState,
  reducers: {
    clearDataPlans: (state) => {
      state.oneTimeDataPlans = [];
    },
    updateDataPlans: (state, action) => {
      state.oneTimeDataPlans = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOneTimeDataPlans.fulfilled, (state, action) => {
        state.isLoading = false;
        state.oneTimeDataPlans = action.payload as TPlanList[];
      })
      .addCase(fetchOneTimeDataPlans.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchOneTimeDataPlans.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

// Action creators are generated for each case reducer function
export const { clearDataPlans, updateDataPlans } = allPlanSlice.actions;

export default allPlanSlice.reducer;
